




























































































































































































































































































import {
  InlinePriceChange,
  InlinePriceChangePayload,
  IPRCFormula,
  IPRCFormulaPayload,
  IPRCLedger,
  IPRCLedgerDeletePayload,
  RateChangesState,
  RateChangeUnit
} from "@/models";
import { rateChangeHeaders } from "@/helpers/iprc/rate-change-headers";
import RateChangesModule from "@/store/modules/rate-changes";
import SnackbarModule from "@/store/modules/snackbar";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { namespace, State } from "vuex-class";

const rateChanges = namespace(RateChangesModule.name);
const snackbar = namespace(SnackbarModule.name);

@Component({
  name: "RateChangeTable"
})
export default class ApplyFormula extends Vue {
  // ===== Refs ===== //
  $refs!: {
    formulaForm: HTMLFormElement;
    formulaValidator: HTMLFormElement;
  }
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  @rateChanges.Action("createInlinePriceChange")
    private createInlinePriceChange!: (payload: InlinePriceChangePayload) => void;
  @rateChanges.Action("createIPRCFormula") private createIPRCFormula!: (formula: IPRCFormula) => void;
  @rateChanges.Action("deleteIPRCFormula") private deleteIPRCFormula!: (id: number) => void;
  @rateChanges.Action("deleteIPRCLedger") private deleteIPRCLedger!: (payload: IPRCLedgerDeletePayload) => void;
  @rateChanges.Action("resetFilters") private resetFilters!: () => void;
  @rateChanges.Action("setSelectedTab") private setSelectedTab!: (selectedTab: number) => void;
  @snackbar.Action("successMessage") private successMessage!: (message: string) => void;
  // ===== Props ===== //
  @Prop(String) private readonly headerDisplay?: string;
  // ===== Data ===== //
  private addFormulaModal = false;
  private allHeaders: DataTableHeader[] = rateChangeHeaders
  private newFormula: IPRCFormula = {
    id: null,
    color: "",
    name: "",
    percent: null,
    min: null,
    max: null,
    created_at: null,
    updated_at: null
  };
  private selectedFormula: IPRCFormula | null = null;
  private selectedLedgerId = 0;
  private selectedUnits: RateChangeUnit[] = [];
  private showDeletePrompt = false;
  // ===== Methods ===== //
  private async applyIPRCFormula(): Promise<void> {
    if (this.selectedFormula && this.selectedUnits.length) {
      const selectedUnitsArr: IPRCFormulaPayload[] = [];
      this.selectedUnits.forEach((unit) => {
        return selectedUnitsArr.push({ formula_id: this.selectedFormula!.id, ledger_id: unit.id });
      });
      const payload = {
        iprc_id: this.selectedIPRCSetID,
        formula_units: selectedUnitsArr
      };
      await this.createInlinePriceChange(payload);
      this.selectedUnits = [];
      this.selectedFormula = null;
    }
  }
  private closeFormulaModal(): void {
    this.addFormulaModal = false;
    this.$refs.formulaForm.reset();
    this.$nextTick(() => { this.$refs.formulaValidator.reset(); });
  }
  private generateFallbackName(): string {
    return `${this.newFormula.percent}% increase, $${this.newFormula.min} Min / $${this.newFormula.max} Max`;
  }
  private handleCancel(): void {
    this.resetFilters();
    this.$router.push({ name: "rateChanges" }).catch(() => { return true; });
  }
  private async handleCreateFormula(): Promise<void> {
    if (!this.newFormula.name) {
      this.newFormula.name = this.generateFallbackName();
    }
    await this.createIPRCFormula(this.newFormula);
    this.closeFormulaModal();
  }
  private async handleDeleteFormula(id: number): Promise<void> {
    await this.deleteIPRCFormula(id);
    this.selectedFormula = null;
    this.showDeletePrompt = false;
  }
  private async handleDeleteLedger(ledger: InlinePriceChange): Promise<void> {
    const payload: IPRCLedgerDeletePayload = {
      id: ledger.ip_change_set_id,
      changeSetId: ledger.ip_price_change_set_id
    };
    await this.deleteIPRCLedger(payload);
    this.selectedLedgerId = 0;
  }
  private async selectUnits(): Promise<void> {
    const formattedUnits: IPRCFormulaPayload[] = [];
    this.selectedUnits.forEach((unit) => formattedUnits.push({ formula_id: null, ledger_id: unit.id }));
    const payload = {
      iprc_id: this.selectedIPRCSetID,
      formula_units: formattedUnits
    };
    await this.createInlinePriceChange(payload);
    this.setSelectedTab(1);
    this.selectedUnits = [];
  }
  private valueColors(formula: string): string {
    if (formula === "MIN") {
      return "warning--text";
    } else if (formula === "PCT") {
      return "primary--text";
    } else if (formula === "MAX") {
      return "success--text";
    }
    return "";
  }
  // ===== Computed ===== //
  get allLedgersAppliedFormula(): boolean {
    return !!(this.rateChanges.selectedUnits.length &&
      this.rateChanges.selectedUnits.every(ledger => ledger.formula_id !== 0));
  }
  get availableHeaders(): DataTableHeader[] {
    if (this.headerDisplay === "review") {
      return this.allHeaders.filter(header => header.value !== "actions");
    } else if (this.headerDisplay === "submit") {
      return this.allHeaders.slice(0, 12);
    } else if (this.headerDisplay === "select") {
      return this.allHeaders.slice(0, 8);
    } else {
      return this.allHeaders.filter(header => header.value !== "status");
    }
  }
  get eligibleLedgers(): IPRCLedger[] {
    const ineligibleUnits: number[] = this.rateChanges.selectedUnits.map(ledger => ledger.id!);
    return this.rateChanges.ledgers.filter(ledger => !ineligibleUnits.includes(ledger.id));
  }
  get formulaApplied(): boolean {
    return !!(this.rateChanges.selectedUnits.length || this.rateChanges.reviewedIPRCSetPriceChanges.length);
  }
  get formulaComplete(): boolean {
    return !!(this.newFormula.color && this.newFormula.max && this.newFormula.min && this.newFormula.percent);
  }
  get rateChangesDataTable(): IPRCLedger[] | InlinePriceChange[] {
    if (this.$route.name === "confirmChange" && this.rateChanges.reviewedIPRCSetPriceChanges.length) {
      return this.rateChanges.reviewedIPRCSetPriceChanges;
    } else if (this.$route.name === "confirmChange" && this.rateChanges.selectedUnits.length) {
      return this.rateChanges.selectedUnits;
    } else if (this.rateChanges.selectedTab === 0) {
      return this.eligibleLedgers;
    } else {
      return this.rateChanges.selectedUnits;
    }
  }
  get rateChangeRoute(): boolean {
    return this.$route.name === "rateChange";
  }
  get selectedIPRCSetID(): number {
    return this.rateChanges.selectedIPRCSet!.id;
  }
  get showDeleteColumn(): boolean {
    return this.rateChanges.selectedUnits && this.rateChangeRoute;
  }
  // ===== Watchers ===== //
  @Watch("rateChanges.selectedUnits")
  private clearFormula(selectedUnits: InlinePriceChange[]) {
    if (!selectedUnits.length) {
      this.selectedFormula = null;
    }
  }
  @Watch("selectedFormula")
  private resetSelectedFormula(formula: IPRCFormula) {
    if (!formula) {
      this.showDeletePrompt = false;
    }
  }
}
